(function ($) {
    $('#btnInputNL').click(function (event) {
        event.preventDefault();
        if (!($('#politicaNewsLetter').is(':checked'))) {
            let opts = {
                title: 'Atenção!',
                text: "É necessário concordar com nossas políticas e receber nosso conteúdo para prosseguir.",
            };
            PNotify.alert(opts);
            return false;
        }
        var nome = $('#nomeNewsLetter').val();
        var email = $('#emailNewsLetter').val();
        var c_umtz = read_cookie("__utmz");
        var traffic_source = read_cookie("__trf.src");
        var client_id = read_cookie("rdtrk") ? JSON.parse(decodeURIComponent(read_cookie("rdtrk"))).id : false;
        var data = {
            'nome': nome,
            'email': email,
            'c_umtz': c_umtz,
            'traffic_source': traffic_source,
            'client_id': client_id
        }
        $.ajax({
            type: "POST",
            data,
            dataType: "JSON",
            url: "https://callbacks.prestus.com.br/siteapi/v1/newsdev", //Variavel criada na criação do JS no functions
            success: function (retorno) {
                if (retorno.status == 1) {
                    let opts = {
                        title: 'Erro!',
                        text: retorno.msg,
                    };
                    PNotify.alert(opts);
                } else {
                    $('#news').hide();
                    $('#newsBtn').hide();

                    let opts = {
                        title: 'Sucesso',
                        text: retorno.msg,
                    };
                    PNotify.alert(opts);
                }
            }
        });
    });

    function read_cookie(a) {
        var b = a + "=";
        var c = document.cookie.split(";");
        for (var d = 0; d < c.length; d++) {
            var e = c[d];
            while (e.charAt(0) == " ") e = e.substring(1, e.length);
            if (e.indexOf(b) == 0) {
                return e.substring(b.length, e.length)
            }
        }
        return null
    }

})(jQuery);